/* ========================================================================
   © 2026 SpeedToLead Framework. All rights reserved.
   ======================================================================== */
export default function SiteFooter() {
    return (
        <footer
            className="border-t border-border bg-background"
            role="contentinfo"
        >
            <div className="mx-auto grid max-w-7xl gap-6 px-6 py-10 md:grid-cols-3 md:px-10">
                <div>
                    <p className="font-display text-lg font-bold tracking-tight">
                        SpeedToLead
                    </p>
                    <p className="mt-2 text-sm text-muted-foreground">
                        Forms in. Calls out. Under 30 seconds.
                    </p>
                </div>
                <div>
                    <p className="font-mono text-xs uppercase tracking-[0.25em] text-muted-foreground">
                        Compliance
                    </p>
                    <p className="mt-2 text-sm text-muted-foreground">
                        WCAG 2.1 AA · Stripe Verified · PCI-DSS Compatible Checkout
                    </p>
                </div>
                <div>
                    <p className="font-mono text-xs uppercase tracking-[0.25em] text-muted-foreground">
                        Build
                    </p>
                    <p className="mt-2 text-sm text-muted-foreground">
                        © 2026 SpeedToLead Framework. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
}
